export default "__VITE_ASSET__DNI2rkC0__"